import { useTranslation } from "react-i18next";
import SvgIcon from "../../parts/SvgIcon";
import { TOTAL_STEPS } from "./wizard-config";

// Footer pager: home icon + back/forward chevrons + "X of 10", plus the
// Back / Skip / Continue actions from the mockups.
const OnboardingFooter = ({
  current,
  canGoBack,
  canSkip,
  onBack,
  onSkip,
  onContinue,
  continueDisabled = false,
  continueLabel,
  homeDisabled = false,
}) => {
  const { t } = useTranslation("auth");

  return (
    <footer className="onboarding-footer">
      <div className="pager">
        <a
          href={homeDisabled ? undefined : "/login"}
          className="pager-home"
          data-button-type="secondary"
          role="button"
          aria-label="home"
          aria-disabled={homeDisabled}
          tabIndex={homeDisabled ? -1 : undefined}
          onClick={homeDisabled ? (e) => e.preventDefault() : undefined}
          data-icon-only
        >
          <SvgIcon src="/img/svg/home-alt.svg" />
        </a>
        <button
          type="button"
          className="pager-chevron"
          data-button-type="secondary"
          onClick={onBack}
          disabled={!canGoBack}
          aria-label="previous"
          data-icon-only
        >
          <SvgIcon src="/img/new-icons/arrow-left.svg" />
        </button>
        <button
          type="button"
          className="pager-chevron"
          data-button-type="secondary"
          onClick={onContinue}
          disabled={continueDisabled}
          aria-label="next"
          data-icon-only
        >
          <SvgIcon src="/img/new-icons/arrow-right.svg" />
        </button>
        <span className="pager-counter">
          {t("onboardingWizard.stepCounter", {
            current,
            total: TOTAL_STEPS,
          })}
        </span>
      </div>

      <div className="actions">
        {canGoBack ? (
          <button
            type="button"
            data-button-type="secondary"
            onClick={onBack}
            sz="large"
          >
            {t("onboardingWizard.back")}
          </button>
        ) : null}
        {canSkip ? (
          <button
            type="button"
            data-button-type="secondary"
            onClick={onSkip}
            sz="large"
          >
            {t("onboardingWizard.skipForNow")}
          </button>
        ) : null}
        <button
          type="button"
          data-button-type="primary"
          onClick={onContinue}
          disabled={continueDisabled}
          sz="large"
        >
          {continueLabel || t("onboardingWizard.continue")}
        </button>
      </div>
    </footer>
  );
};

export default OnboardingFooter;
